import { get } from 'lodash/fp';

/*
 * file of sorter functions to be passed to sorter param
 * of antd column library to assist in sorting tables
 */

export const sortStrings = (objectA, objectB, fieldToSortBy) => {
  try {
    const stringA = get(fieldToSortBy)(objectA);
    const stringB = get(fieldToSortBy)(objectB);
    return stringA.localeCompare(stringB);
  } catch (e) {
    return 0;
  }
};

export const sortNumbers = (objectA, objectB, fieldToSortBy) => {
  try {
    const numberA = get(fieldToSortBy)(objectA);
    const numberB = get(fieldToSortBy)(objectB);
    return numberA - numberB;
  } catch (e) {
    return 0;
  }
};

export const sortDates = (objectA, objectB, fieldToSortBy) => {
  try {
    const dateA = get(fieldToSortBy)(objectA) || new Date();
    const dateB = get(fieldToSortBy)(objectB) || new Date();
    return new Date(dateA) - new Date(dateB);
  } catch (e) {
    return 0;
  }
};
